import $ from 'jquery';
import { Component } from 'react';

class EmptyChart extends Component {
  constructor() {
    super();
    this.id = Date.now();
  }

  componentDidMount() {
    let $ele = $(`#${this.id}`);
    let newHeight = $ele
      .closest('.row')
      .find('.js-widget-content')
      .innerHeight();
    $ele.css('height', newHeight);
  }

  render() {
    let styles = {
      textAlign: 'center',
      minHeight: '200px',
      transform: 'translateY(40%)',
    };
    return (
      <div id={this.id} style={styles}>
        No data found
      </div>
    );
  }
}

export default EmptyChart;
